/*
 *
 * Siderbar constants
 *
 */

export const DEFAULT_ACTION = 'app/Sidebar/DEFAULT_ACTION';
export const SIDEBAR_SHOW = 'app/Sidebar/SIDEBAR_SHOW';
export const INDICATOR_CHANGE = 'app/Sidebar/INDICATOR_CHANGE';
